import {provideConfig} from "@spartacus/core";
import {defaultB2bOccConfig} from "@spartacus/setup";

export const environment = {
  production: false,
  gtmId: 'GTM-TZTLJVK',
  b2bOccConfig: provideConfig(defaultB2bOccConfig),
};
